import { render, staticRenderFns } from "./ComplianceList.vue?vue&type=template&id=63ba909e"
import script from "./ComplianceList.vue?vue&type=script&lang=js"
export * from "./ComplianceList.vue?vue&type=script&lang=js"
import style0 from "./ComplianceList.vue?vue&type=style&index=0&id=63ba909e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports